'use client';

import ProductTruefitCTA from './product-truefit-cta';
import useTrueFit from '@app/lib/hooks/use-truefit';

interface ProductTruefitProps {
    productID: string;
    locale: string;
    onCTAClick: (src: string, key: string) => void;
    uiKey: string;
    triggerRefetch: boolean;
}

const ProductTruefit = ({
    productID,
    locale,
    onCTAClick,
    uiKey,
    triggerRefetch,
}: ProductTruefitProps) => {
    const { loading, error, recommendation } = useTrueFit(
        productID,
        locale,
        triggerRefetch
    );
    const fitMessage = recommendation?.message;
    const ctaURL = recommendation?.cta?.url;
    const iframeSrc = ctaURL
        ? `${ctaURL}&originUrl=${encodeURIComponent(window.location.href)}`
        : '';

    const handleTruefitCTAClick = () => {
        onCTAClick(iframeSrc, uiKey);
    };

    if (error) return;

    return (
        <ProductTruefitCTA
            loading={loading}
            ctaMessage={recommendation?.cta?.message}
            fitMessage={fitMessage}
            onClick={handleTruefitCTAClick}
        />
    );
};

export default ProductTruefit;
